import { useState, useCallback, useMemo } from "react";
import Box from "@mui/material/Box";
import { SearchToggle } from "@/components/ui/SearchToggle";
import { InstallSectionCard } from "../InstallSectionCard";
import { EmptyState } from "../../../../components/EmptyState";
import { useCompanyPageStore } from "../../../../../../store/companyPageStore";
import { InstallsTable } from "./InstallsTable";

export const ProductInstalls = () => {
  const company = useCompanyPageStore((state) => state.company);
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchChange = useCallback((value: string) => {
    setSearchTerm(value);
  }, []);

  const actions = useMemo(
    () => (
      <SearchToggle
        searchTerm={searchTerm}
        onSearchChange={handleSearchChange}
        placeholder="Search products, vendors, or categories"
        width={300}
      />
    ),
    [searchTerm, handleSearchChange]
  );

  if (!company) {
    return (
      <InstallSectionCard
        title="Product Installs"
        actions={actions}
        height={720}
        filterKey="PRODUCT_INSTALLS"
      >
        <EmptyState description="No company data available" />
      </InstallSectionCard>
    );
  }

  return (
    <InstallSectionCard
      title="Product Installs"
      actions={actions}
      height={720}
      noTitleMargin
      filterKey="PRODUCT_INSTALLS"
    >
      <Box data-testid="company-detail-install-products-table">
        <InstallsTable hgId={company.hgId} searchTerm={searchTerm} />
      </Box>
    </InstallSectionCard>
  );
};
